import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackLandingView, trackStartCtaClick } from "@/lib/analytics";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_bdf-method-eval/artifacts/j49n656f_ChatGPT%20Image%2015%20lug%202026%2C%2016_01_15.png";

export default function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    trackLandingView();
  }, []);

  const handleStart = () => {
    trackStartCtaClick();
    navigate("/info");
  };

  return (
    <div className="min-h-screen w-full flex flex-col bg-[#F9F8F6]">
      {/* Hero: image only, full-bleed, natural aspect, no overlays.
          On tall images vs short viewports, cap height so the CTA below stays above the fold. */}
      <section
        className="relative w-full aspect-[3/2] max-h-[calc(100vh-160px)] overflow-hidden"
        data-testid="welcome-hero-section"
      >
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          src={HERO_IMG}
          alt="Metodo BDF - Breath Dance Flow - Eliana Bassotto"
          className="w-full h-full object-cover object-center block"
          data-testid="welcome-hero-image"
        />
      </section>

      {/* CTA below hero */}
      <section className="w-full py-16 sm:py-20 px-6 sm:px-10 flex flex-col items-center justify-center text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <Button
            onClick={handleStart}
            size="lg"
            data-testid="start-assessment-button"
            className="rounded-full px-10 h-14 bg-[#1E3F33] hover:bg-[#2A5243] text-white text-sm tracking-[0.1em] uppercase font-semibold transition-all hover:shadow-xl group"
          >
            Inizia il tuo Assessment
            <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Button>
          <div className="mt-5 text-xs uppercase tracking-[0.18em] text-[#5C7368]" data-testid="welcome-duration">
            Durata stimata: 5–7 minuti
          </div>
        </motion.div>
      </section>
    </div>
  );
}
